module.exports = __webpack_public_path__ + "img/4.62ec0cb1.jpg";